import Image from "next/image";
import { Box, Typography } from "@mui/material";

const InvalidServiceAlert = () => {
  return (
    <Box
      sx={{
        display: "inline-flex",
        p: 2,
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        borderRadius: 1,
        border: "1px solid #FFB0A8",
        background: "#FFD8D5",
        margin: "0 auto !important",
        fontFamily: "ABCDiaTypeRegular",
        maxWidth: { xs: "380px", lg: "650px" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <Image alt="" src="/exclamation.png" height={20} width={20} />
        <Typography color="#A10000" sx={{ fontFamily: "ABCDiaTypeBold" }}>
          Unknown Service Selected
        </Typography>
      </Box>
      <Typography
        color="#A10000"
        align="center"
        fontSize="16px"
        sx={{ lineHeight: "22.4px", letterSpacing: "-0.16px" }}
      >
        Unfortunately the Service you have selected is not valid. Please contact
        support at{" "}
        <a href="mailto:support@thrivelab.com">support@thrivelab.com</a> or call
        or text us at <a href="tel:737-377-1600">737-377-1600</a>
      </Typography>
    </Box>
  );
};

export default InvalidServiceAlert;
